import React, {Component, Fragment} from 'react';
import {
  ListGroup,
  ListGroupItem,
} from 'reactstrap';
import {SortableHandle} from "react-sortable-hoc";
import ReactTooltip from 'react-tooltip';

const DragHandle = SortableHandle(() =>

    <div className='move-item' data-tip="Drag phases to reorder">
      <ReactTooltip place="top" className='customTheme' effect="solid"/>
      <i className='fa fa-chevron-up'/>
      <i className='fa fa-chevron-down'/>
    </div>

);

class TrainingPhaseDetailCard extends Component {
  constructor(props) {
    super(props);
    this.state = {dropdownOpen: false};
  }

  // ----------------------
  // State setters
  // ----------------------

  toggle() {
    this.setState({dropdownOpen: !this.state.dropdownOpen});
  }

  // ----------------------
  // Render
  // ----------------------

  render() {
    return (
      <div className="timeline-item">

        {/*<i className='fa fa-chevron-up'/>*/}
        <div className="timeline-item-header">
          {this.props.phase.header}
        </div>
        {/*<i className='fa fa-chevron-down'/>*/}

        <div className="card timeline-item-content">

          {(this.props.actions.canEdit || this.props.actions.canDelete || this.props.actions.canMove) &&
          <div className="card-header timeline-item-actions">
            <Fragment>
              <div>
                {this.props.actions.canEdit &&
                <button className='button small secondary' onClick={this.props.onEdit}>
                  <i className="fa fa-edit"></i> Edit
                </button>
                }
                {this.props.actions.canDelete &&
                <button className='button small delete' onClick={this.props.onDelete}>
                  <i className="fa fa-trash"></i> Delete
                </button>
                }
              </div>

              {this.props.actions.canMove && <DragHandle/>}

            </Fragment>
          </div>
          }


          <div className="card-body timeline-item-body">

            {this.props.phase.type === 'observation' && (
            <Fragment>

              <ListGroup className="list-group-flush mb-3">
                <ListGroupItem>Weeks:</ListGroupItem>
                <ListGroupItem>{this.props.phase.weeks}</ListGroupItem>
              </ListGroup>
            </Fragment>
            )}

            <ListGroup className="list-group-flush mb-3">
              <ListGroupItem>Hours:</ListGroupItem>
              <ListGroupItem>{this.props.phase.hours}</ListGroupItem>
            </ListGroup>

            <ListGroup className="list-group-flush">
              {this.props.phase.forms.map((form, index) => (
                <Fragment key={parseInt(index, 10)}>
                  <ListGroupItem>Type {form.key}   </ListGroupItem>
                  {this.props.phase.type === 'observation' && (
                    <ListGroupItem>Minimum {form.min}</ListGroupItem>
                  )}
                </Fragment>
              ))}
            </ListGroup>
          </div>
        </div>
      </div>
    );
  }
}

export default TrainingPhaseDetailCard;
